import { LicenseInfo } from "@mui/x-license-pro";

export interface LicenseProps {
  dataGridProKey: string;
}

export default function addLicense(props: LicenseProps) {
  const { dataGridProKey } = props;

  LicenseInfo.setLicenseKey(dataGridProKey!);
}
